// Video AutoPlay
try {
  const videos = document.querySelectorAll(".lazy-video");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const video = entry.target;

        video.muted = true;
        video.play().catch(() => {});

        observer.unobserve(video);
      }
    });
  });

  videos.forEach((v) => observer.observe(v));
} catch (error) {
  console.log(error);
}

//Swiper Slider Product section
try {
  function productSwiper() {
    let swiperContainer = document.querySelectorAll(
      ".custom-product-swiper-container",
    );
    if (!swiperContainer) return;
    let width = window.innerWidth;
    swiperContainer.forEach((swiper) => {
      if (width > 1024) {
        swiper.setAttribute("slides-per-view", "4");
      } else if (width > 768) {
        swiper.setAttribute("slides-per-view", "3");
      } else if (width > 325) {
        swiper.setAttribute("space-between", "10");
        swiper.setAttribute("slides-per-view", "1.2");
      }
    });
  }
  productSwiper();
  window.addEventListener("resize", productSwiper);
} catch (error) {
  console.log(error);
}

//Swiper Slider Collection Section
try {
  function productSwiper() {
    let swiperContainer = document.querySelector(
      ".custom-product-col-card-swiper-con",
    );
    if (!swiperContainer) return;
    let width = window.innerWidth;
    if (width > 1024) {
      swiperContainer.setAttribute("slides-per-view", "3");
    } else if (width > 768) {
      swiperContainer.setAttribute("slides-per-view", "3");
    } else if (width > 325) {
      swiperContainer.setAttribute("space-between", "10");
      swiperContainer.setAttribute("slides-per-view", "1.1");
    }
  }
  productSwiper();
  window.addEventListener("resize", productSwiper);
} catch (error) {
  console.log(error);
}

//Cart Drawer Toggle
try {
  let cartOpenBtn = document.querySelector(".cart-open-btn");
  let cartDrawer = document.querySelector(".custom-cart-drawer");
  let cartDrawerWrapper = document.querySelector(".custom-cart-container");
  let cartCloseBtn = document.querySelector(".custom-cart-drawer-top svg");

  cartOpenBtn.addEventListener("click", () => {
    if (window.location.href.includes("/cart")) return;
    cartDrawer.classList.add("cart-drawer-open");
    cartDrawerWrapper.classList.add("drawer-wrapper-open");
  });

  cartCloseBtn.addEventListener("click", () => {
    cartDrawer.classList.remove("cart-drawer-open");
    cartDrawerWrapper.classList.remove("drawer-wrapper-open");
  });

  cartDrawerWrapper.addEventListener("click", (e) => {
    if (e.target.closest(".custom-cart-drawer")) return;
    e.stopPropagation();
    cartDrawer.classList.remove("cart-drawer-open");
    cartDrawerWrapper.classList.remove("drawer-wrapper-open");
  });
} catch (error) {
  console.log(error);
}

//Quantity
try {
  let plusBtn = document.querySelector(".custom-product-qty-plus-btn");
  let minusBtn = document.querySelector(".custom-product-qty-minus-btn");
  let qtyInput = document.querySelector(".product-page-qty");
  // let maxInputValue = qtyInput.getAttribute("data-max");

  plusBtn.addEventListener("click", () => {
    // if (qtyInput.value <= maxInputValue) {
    qtyInput.value = Number(qtyInput.value) + 1;
    // }
  });

  minusBtn.addEventListener("click", () => {
    if (qtyInput.value > 1) {
      qtyInput.value = Number(qtyInput.value) - 1;
    }
  });
} catch (error) {
  console.log(error);
}

//Product ADD TO CART || BUY NOW
try {
  let product = document.querySelector(".custom-product-page-wrapper");
  // let productID = product ? product.getAttribute("product-id") : null;
  let productVariant = product
    ? JSON.parse(product.getAttribute("product-variants"))
    : null;
  let cartBottom = document.querySelector(".custom-cart-drawer-bottom");
  let cartExtra = document.querySelector(".custom-cart-drawer-extra");
  let cartDrawer = document.querySelector(".custom-cart-drawer");
  let cartDrawerWrapper = document.querySelector(".custom-cart-container");
  let buyButton = document.querySelector(".buy-btn");
  // let productRemoveBtn = document.querySelector(".custom-cart-item-buttons svg");

  function showNotification(msg) {
    let notificationWrapper = document.querySelector(
      ".custom-notification-wrapper",
    );
    notificationWrapper.style.opacity = "1";
    notificationWrapper.style.pointerEvents = "all";
    notificationWrapper.querySelector("p").textContent = msg.description;

    setTimeout(() => {
      notificationWrapper.style.opacity = "0";
      notificationWrapper.style.pointerEvents = "none";
    }, 5000);
  }

  async function ADDTOCART(id, qty, button) {
    try {
      let formData;
      // ✅ ONLY for main product
      // console.log(id, id.length);
      if (button.classList.contains("main-product-atc")) {
        let sellingPlan = document.querySelector(
          '[name="selling_plan"]',
        )?.value;

        console.log("Selling Plan:", sellingPlan);

        formData = {
          items: [
            {
              id: id,
              quantity: qty,
              ...(sellingPlan && { selling_plan: sellingPlan }),
            },
          ],
        };
      } else {
        if (id.length > 0) {
          formData = {
            items: id.map((singleId) => ({
              id: singleId,
              quantity: qty,
            })),
          };
        } else {
          formData = {
            items: [{ id: id, quantity: qty }],
          };
        }
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (!response.ok) {
        showNotification(data);
        return false;
      }

      console.log("Added to cart:", data);
      await updateCartDrawer();
      return true;
    } catch (err) {
      console.error("Error:", err);
    }
  }

  async function updateCartDrawer() {
    const localeRoot = window.Shopify?.routes?.root || "/";
    // console.log(localeRoot);
    let data = await fetch(`${localeRoot}?section_id=custom-cart-drawer`);
    // let data = await fetch("/?section_id=custom-cart-drawer");
    let text = await data.text();
    // console.log(text);
    let DIV = document.createElement("DIV");
    DIV.innerHTML = text;
    cartBottom = document.querySelector(".custom-cart-drawer-bottom");
    cartExtra = document.querySelector(".custom-cart-drawer-extra");
    let updatedCartBottom = DIV.querySelector(".custom-cart-drawer-bottom");
    let updatedCartExtra = DIV.querySelector(".custom-cart-drawer-extra");

    if (cartBottom && updatedCartBottom) {
      cartBottom.innerHTML = updatedCartBottom.innerHTML;
    }

    if (cartExtra && updatedCartExtra) {
      cartExtra.innerHTML = updatedCartExtra.innerHTML;
    }

    // Update Cart Count
    const cart = await fetch("/cart.js").then((res) => res.json());
    document.querySelector(".cart-count-span").textContent = cart.item_count;
  }

  function cartOpen() {
    cartDrawer.classList.add("cart-drawer-open");
    cartDrawerWrapper.classList.add("drawer-wrapper-open");
  }

  function getVariantID() {
    let radios = document.querySelectorAll(
      ".variant-option input[type='radio']:checked",
    );
    // if (!radios) return;
    let selectedVariant = [];

    radios.forEach((radio) => {
      selectedVariant.push(radio.value);
    });

    console.log(selectedVariant);
    console.log(productVariant);

    if (productVariant.length == 1) {
      console.log(productVariant[0]);
      return productVariant[0];
    } else {
      const matchedVariant = productVariant.find((v) =>
        v.options.every((opt, i) => opt === selectedVariant[i]),
      );
      return matchedVariant;
    }
  }

  document.addEventListener("click", async (e) => {
    let btn = e.target.closest(".a-t-c-btn");
    // let btn = null;
    if (!btn) return;
    let productID = btn ? Number(btn.getAttribute("product-id")) : false;

    // console.log("sdghjkl");
    if (!productID) {
      let variant = getVariantID();
      let variantID = variant ? variant.id : null;
      if (!variantID) return;
      let qty = document.querySelector(".product-page-qty")
        ? Number(document.querySelector(".product-page-qty").value)
        : 1;
      let added = await ADDTOCART(variantID, qty, btn);
      if (added) cartOpen();
      return;
    }

    let qty = 1;
    let added = await ADDTOCART(productID, qty, btn);
    if (added) cartOpen();
  });

  document.addEventListener("click", async (e) => {
    let btn = e.target.closest(".buy-btn");
    if (!btn) return;

    let productID = btn ? btn.getAttribute("product-id") : false;
    if (!productID) {
      let variantID = getVariantID().id ? getVariantID().id : null;
      let qty = document.querySelector(".product-page-qty")
        ? Number(document.querySelector(".product-page-qty").value)
        : 1;
      let added = await ADDTOCART(variantID, qty);
      if (added) window.location.href = "/checkout";
    }

    let qty = document.querySelector(".product-page-qty")
      ? Number(document.querySelector(".product-page-qty").value)
      : 1;
    let added = await ADDTOCART(productID, qty);
    if (added) window.location.href = "/checkout";
  });

  document.addEventListener("click", async (e) => {
    let remove_btn = e.target.closest(".custom-cart-item-buttons svg");
    if (!remove_btn) return;
    let product_id = remove_btn.getAttribute("remove-product-id");
    cartBottom.style.opacity = 0.6;

    //Ajax Api Template
    const payload = {
      id: product_id,
      quantity: 0,
    };
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );
      const result = await response.json();
      console.log("✅ Removed form cart:", result);
      await updateCartDrawer();
      cartBottom.style.opacity = 1;
      return result;
    } catch (error) {
      console.error("❌ Failed to change cart item quantity:", error);
      return null;
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    const variants = productVariant;
    if (!variants || !variants.length) return;
    let radios = document.querySelectorAll("input[type='radio']");
    const sizeRadios = document.querySelectorAll('input[name="option-1"]');
    const colorRadios = document.querySelectorAll('input[name="option-2"]');

    /* ----------------------------
     1️⃣ Select first available variant
  ---------------------------- */
    const firstAvailable = variants.find((v) => v.available);
    if (!firstAvailable) {
      radios.forEach((r) => {
        r.disabled = true;
        r.closest(".variant-option").classList.add("variant-out-of-stock");
      });

      const atcBtn = document.querySelectorAll(
        ".custom-product-qty-n-btn-wrapper .a-t-c-btn",
      );
      const buyBtn = document.querySelectorAll(
        ".custom-product-button-wrapper .buy-btn",
      );
      const qtyInput = document.querySelectorAll(
        ".custom-product-qty-n-btn-wrapper .custom-product-qty",
      );

      if (atcBtn) {
        atcBtn.forEach((btn) => {
          btn.textContent = "Out Of Stock";
          btn.classList.add("addtocart-class");
        });
      }

      if (buyBtn) {
        buyBtn.forEach((btn) => {
          btn.style.display = "none";
        });
      }

      if (qtyInput) {
        qtyInput.forEach((input) => {
          input.style.display = "none";
        });
      }
    }

    const selectRadio = (name, value) => {
      const r = document.querySelector(
        `input[name="${name}"][value="${value}"]`,
      );
      if (r) r.checked = true;
    };

    selectRadio("option-1", firstAvailable.options[0]);
    selectRadio("option-2", firstAvailable.options[1]);

    /* ----------------------------
     2️⃣ Update SIZE availability
  ---------------------------- */
    const updateSizes = () => {
      sizeRadios.forEach((sizeRadio) => {
        const sizeValue = sizeRadio.value;

        const hasAnyAvailable = variants.some(
          (v) => v.available && v.options[0] === sizeValue,
        );

        sizeRadio.disabled = !hasAnyAvailable;
        sizeRadio
          .closest(".variant-option")
          ?.classList.toggle("variant-out-of-stock", !hasAnyAvailable);
      });
    };

    /* ----------------------------
     3️⃣ Update COLOR availability
  ---------------------------- */
    const updateColors = () => {
      const selectedSize = document.querySelector(
        'input[name="option-1"]:checked',
      )?.value;

      if (!selectedSize) return;

      colorRadios.forEach((colorRadio) => {
        const colorValue = colorRadio.value;

        const isAvailable = variants.some(
          (v) =>
            v.available &&
            v.options[0] === selectedSize &&
            v.options[1] === colorValue,
        );

        colorRadio.disabled = !isAvailable;
        colorRadio
          .closest(".variant-option")
          ?.classList.toggle("variant-out-of-stock", !isAvailable);
      });

      // Auto-select first available color
      const checkedColor = document.querySelector(
        'input[name="option-2"]:checked',
      );
      if (!checkedColor || checkedColor.disabled) {
        const firstAvailableColor = Array.from(colorRadios).find(
          (r) => !r.disabled,
        );
        if (firstAvailableColor) firstAvailableColor.checked = true;
      }
    };

    /* ----------------------------
     4️⃣ Init
  ---------------------------- */
    updateSizes();
    updateColors();

    /* ----------------------------
     5️⃣ Events
  ---------------------------- */
    sizeRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        updateColors();
      });
    });
  });

  // Auto Select Variant
  function autoSelectVariant() {
    document.addEventListener("DOMContentLoaded", () => {
      const params = new URLSearchParams(window.location.search);
      const variantId = params.get("variant");
      if (variantId) {
        const selectedVariant = productVariant.find((v) => v.id == variantId);
        // console.log(selectedVariant);

        if (selectedVariant.available) {
          let inputRadio = document.querySelector(
            `input[type='radio'][value='${selectedVariant.title}']`,
          );
          if (inputRadio) {
            setTimeout(() => {
              inputRadio.checked = true;
            }, 1000);

            return;
          }
        }
        // console.log(inputRadio);
      }
    });
  }
  autoSelectVariant();

  function ritualProductCount() {
    let count = document.querySelectorAll(".routine-product input:checked");
    document.querySelector(".ritual-product-selected span").innerHTML =
      count.length;

    // console.log(count.length);
  }

  // -------------------------------
  // Ritual Code
  // -------------------------------
  document.addEventListener("click", async (e) => {
    let btn = e.target.closest(".ritual-a-t-c-btn");
    if (!btn) return;

    let selectedProducts = document.querySelectorAll(
      ".custom-ritual-products .custom-ritual-product",
    );

    console.log(selectedProducts);
    if (selectedProducts.length == 0) {
      alert("Select Product");
      return;
    }

    btn.classList.add("ritual-btn-class");

    let selectedProducts_IDs = [];

    selectedProducts.forEach((product) => {
      let product_ID = product.getAttribute("ritual-product-id");

      if (product_ID.includes(",")) {
        product_ID.split(",").forEach((id) => {
          selectedProducts_IDs.push(id.trim());
        });
      } else {
        selectedProducts_IDs.push(product_ID);
      }
    });

    // ✅ remove duplicates
    selectedProducts_IDs = [...new Set(selectedProducts_IDs)];

    // console.log(selectedProducts_IDs);

    // let added = false;
    // for (const id of selectedProducts_IDs) {
    let qty = 1;
    const added = await ADDTOCART(selectedProducts_IDs, qty, btn);
    // if (result) added = true;
    // }

    if (added) {
      btn.classList.remove("ritual-btn-class");
      cartOpen();
    }

    //Open Discount Code
    // let selectedProductCount = document.querySelector(
    //   ".ritual-product-selected span",
    // ).textContent;
    // let discountPopUP = document.querySelector(
    //   `.discount-code-popup-wrapper[discount-pack-size='pack-of-${Number(selectedProductCount)}']`,
    // );

    // if (discountPopUP) {
    //   discountPopUP.style.display = "flex";
    //   let popupCon = document.querySelector(".discount-code-popup-container");
    //   popupCon?.classList.add("discount-code-popup-container-class");
    //   // console.log(discountPopUP);

    //   popupCon?.addEventListener("click", (e) => {
    //     if (e.target.closest(".discount-code-popup-wrapper")) return;
    //     e.stopPropagation();
    //     discountPopUP.style.display = "none";
    //     popupCon?.classList.remove("discount-code-popup-container-class");
    //   });

    //   setTimeout(() => {
    //     discountPopUP.style.display = "none";
    //     popupCon?.classList.remove("discount-code-popup-container-class");
    //   }, 5000);
    // }
    //................
  });

  document.addEventListener("click", (e) => {
    let product = e.target.closest(".routine-product input[type='checkbox']");
    // let product = e.target.closest(
    //   ".custom-bg-txt-sections-text-content-headings",
    // );

    if (!product) return;

    // console.log("clicked");

    let selectedProducts = document.querySelectorAll(
      ".routine-product input[type='checkbox']:checked",
    );
    // let selectedProducts = document.querySelectorAll(
    //   ".custom-ritual-products .custom-ritual-product",
    // );
    // console.log(selectedProducts);

    ritualProductCount();
    // console.log(count);
    let ritualSubtotal = 0;
    selectedProducts.forEach((product) => {
      let price = Number(product.getAttribute("product-price"));
      // let price = product
      //   .querySelector(".custom-ritual-product-price span").getAttribute("ritual-product-price");

      // console.log("Hello" + price);
      ritualSubtotal = ritualSubtotal + Number(price);
    });

    // console.log(ritualSubtotal);

    let ritualSubtotalSpan = document.querySelector(".ritual-subtotal");
    ritualSubtotalSpan.innerHTML = `${Shopify.currency.active} ${(ritualSubtotal / 100).toFixed(2)}`;
  });

  document.addEventListener("click", (e) => {
    let btn = e.target.closest(".custom-routine-layer-product");
    if (!btn) return;

    // console.log(btn);
    let checkboxes = btn.parentElement.querySelectorAll(
      ".custom-routine-products-wrapper label input",
    );

    // let selectedRoutineProductCheckbox = btn.parentElement.querySelectorAll(
    //   ".custom-routine-products-wrapper label input[type='checkbox']:checked",
    // );

    // console.log(selectedRoutineProductCheckbox);

    let routine_StepName = btn.parentElement
      .querySelector(".step-name-0")
      .textContent.trim();

    let ritual_EmptyProducts = document.querySelectorAll(
      ".custom-ritual-products div",
    );

    ritual_EmptyProducts.forEach((ritualProduct) => {
      let ritualStepName = ritualProduct.getAttribute("data-step-name");
      if (ritualStepName == routine_StepName) {
        let ritual_Product = document.querySelector(
          `div[data-step-name='${ritualStepName}']`,
        );

        let final_price = 0;
        let product_Name = [];
        let routineProductIDs = [];

        checkboxes.forEach((selectedroutine_product) => {
          product_Name.push(
            selectedroutine_product.getAttribute("product-name"),
          );
          let product_Price =
            Number(selectedroutine_product.getAttribute("product-price")) / 100;
          routineProductIDs.push(
            selectedroutine_product.getAttribute("routine-product-id"),
          );
          final_price += product_Price;
        });

        let ritual_Product_Name = ritual_Product.querySelector(
          ".custom-ritual-product-title p",
        );
        let ritual_Product_StepName = ritual_Product.querySelector(
          ".custom-ritual-product-title span",
        );
        let ritual_Product_Price = ritual_Product.querySelector(
          ".custom-ritual-product-price span",
        );

        ritual_Product?.setAttribute("ritual-product-id", routineProductIDs);

        let finalPName = "";
        product_Name.forEach((Pname) => {
          finalPName += `${Pname},&nbsp;`;
          ritual_Product_Name.innerHTML = finalPName;
        });

        ritual_Product_StepName.innerHTML = ritualStepName;

        ritual_Product_Price.innerHTML = `${Shopify.currency.active} ${final_price.toFixed(2)}`;

        ritual_Product_Price?.setAttribute(
          "ritual-product-price",
          final_price * 100,
        );

        // console.log(product_Name, final_price);

        ritual_Product?.classList.remove("custom-ritual-product-empty");
        ritual_Product?.classList.add("custom-ritual-product");

        checkboxes.length;
      }
    });

    // console.log(checkboxes);
    checkboxes.forEach((checkbox) => {
      // checkbox.setAttribute("type", "checkbox");
      // setTimeout(() => {
      checkbox.checked = true;
      // }, 500);
    });
    // document
    //   .querySelector(".custom-bg-txt-sections-text-content-headings")
    //   .click();

    let selectedProducts = document.querySelectorAll(
      ".routine-product input[type='checkbox']:checked",
    );
    // let selectedProducts = document.querySelectorAll(
    //   ".custom-ritual-products .custom-ritual-product",
    // );
    console.log(selectedProducts);

    ritualProductCount();
    // console.log(count);
    let ritualSubtotal = 0;
    selectedProducts.forEach((product) => {
      let price = Number(product.getAttribute("product-price"));
      // let price = product
      //   .querySelector(".custom-ritual-product-price span").getAttribute("ritual-product-price");

      // console.log("Hello" + price);
      ritualSubtotal = ritualSubtotal + Number(price);
    });

    console.log(ritualSubtotal);

    let ritualSubtotalSpan = document.querySelector(".ritual-subtotal");
    ritualSubtotalSpan.innerHTML = `${Shopify.currency.active} ${(ritualSubtotal / 100).toFixed(2)}`;
  });

  document.addEventListener("click", (e) => {
    let checkbtn = e.target.closest(".routine-product input[type='checkbox']");
    if (!checkbtn) return;

    // console.log("aaa");

    let btn = checkbtn.parentElement.closest(
      ".custom-bg-txt-sections-text-content-headings",
    );
    // .querySelector(".custom-routine-layer-product");

    let checkboxes = btn.querySelectorAll(
      ".custom-routine-products-wrapper label input:checked",
    );
    // console.log(checkboxes);
    // console.log(checkboxes.length);

    // console.log(layerProductBtn);

    // let btnparentElement = btn.closest(".custom-routine-products-wrapper");
    // btnparentElement
    //   .querySelectorAll("input[type='checkbox']")
    //   .forEach((box) => {
    //     box.setAttribute("type", "radio");
    //   });

    // // console.log(btn);
    // btn.checked = true;
    // setTimeout(() => {
    //   btn.click();
    // }, 50);

    let routine_StepName = btn.parentElement
      .querySelector(".step-name-0")
      .textContent.trim();

    let ritual_EmptyProducts = document.querySelectorAll(
      ".custom-ritual-products div",
    );

    if (checkboxes.length == 0) {
      let productToBeEmpty = document.querySelector(
        `.custom-ritual-product[data-step-name='${routine_StepName}']`,
      );
      // console.log(productToBeEmpty);
      productToBeEmpty.classList.remove("custom-ritual-product");
      productToBeEmpty.classList.add("custom-ritual-product-empty");

      productToBeEmpty.querySelector(
        ".custom-ritual-product-title p",
      ).textContent = routine_StepName;
      productToBeEmpty.querySelector(
        ".custom-ritual-product-title span",
      ).textContent = "Not Selected";

      productToBeEmpty
        .querySelector(".ritual-product-price")
        .setAttribute("ritual-product-price", "0.0");
      productToBeEmpty.querySelector(".ritual-product-price").textContent = "-";
    } else {
      ritual_EmptyProducts.forEach((ritualProduct) => {
        let ritualStepName = ritualProduct.getAttribute("data-step-name");
        if (ritualStepName == routine_StepName) {
          let ritual_Product = document.querySelector(
            `div[data-step-name='${ritualStepName}']`,
          );

          let final_price = 0;
          let product_Name = [];
          let routineProductIDs = [];

          checkboxes.forEach((selectedroutine_product) => {
            product_Name.push(
              selectedroutine_product.getAttribute("product-name"),
            );
            let product_Price =
              Number(selectedroutine_product.getAttribute("product-price")) /
              100;
            routineProductIDs.push(
              selectedroutine_product.getAttribute("routine-product-id"),
            );
            final_price += product_Price;
            // console.log(final_price)
            // console.log(product_Price)
          });

          let ritual_Product_Name = ritual_Product.querySelector(
            ".custom-ritual-product-title p",
          );
          let ritual_Product_StepName = ritual_Product.querySelector(
            ".custom-ritual-product-title span",
          );
          let ritual_Product_Price = ritual_Product.querySelector(
            ".custom-ritual-product-price span",
          );

          ritual_Product?.setAttribute("ritual-product-id", routineProductIDs);

          let finalPName = "";
          product_Name.forEach((Pname) => {
            finalPName += `${Pname},&nbsp;`;
            ritual_Product_Name.innerHTML = finalPName;
          });

          ritual_Product_StepName.innerHTML = ritualStepName;

          ritual_Product_Price.innerHTML = `${Shopify.currency.active} ${final_price.toFixed(2)}`;

          ritual_Product_Price.setAttribute(
            "ritual-product-price",
            final_price * 100,
          );

          // console.log(product_Name, final_price);

          ritual_Product?.classList.remove("custom-ritual-product-empty");
          ritual_Product?.classList.add("custom-ritual-product");

          checkboxes.length;
        }
      });
    }

    // ritualProductCount();
  });
} catch (error) {
  console.log(error);
}

// Price Change || Variant Image
try {
  setTimeout(() => {
    let variantRadios = document.querySelectorAll(
      ".variant-option input[type='radio']",
    );
    let product = document.querySelector(".custom-product-page-wrapper");
    // let productID = product ? product.getAttribute("product-id") : null;
    let productVariant = product
      ? JSON.parse(product.getAttribute("product-variants"))
      : null;
    let productPrice = document.querySelector(".product-page-price");
    let productComparePrice = document.querySelector(
      ".product-page-compare-price",
    );
    let discountPer = document.querySelector(".custom-product-price-off-tag");

    variantRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        updatePrice();
        updateVariant();
      });
    });

    function updatePrice() {
      try {
        let slsProductPrice = document
          .querySelector("[data-one-time-option-radio]")
          ?.parentElement?.querySelector(".seal-money");
        // console.log(slsProductPrice);
        let slsProductComparePrice = document
          .querySelector("[data-selling-plan-group-option-radio]")
          ?.parentElement?.querySelector(".sls-price");

        // console.log(slsProductComparePrice, slsProductPrice);

        let selectedRadiosArr = [];
        let selectedRadios = document.querySelectorAll(
          ".variant-option input[type='radio']:checked",
        );
        selectedRadios.forEach((radio) => {
          selectedRadiosArr.push(radio.value);
        });
        // console.log(selectedRadiosArr);

        const matchedVariant = productVariant.find((v) =>
          v.options.every((opt, i) => opt === selectedRadiosArr[i]),
        );

        // console.log(matchedVariant);
        if (!matchedVariant) return;

        let newPrice = matchedVariant.price / 100;
        let newComparePrice = matchedVariant.compare_at_price / 100;

        let finalPrice = newComparePrice - newPrice;
        const finalPercentage = (finalPrice * 100) / newComparePrice;

        if (productPrice) {
          productPrice.innerHTML = `${newPrice.toFixed(2)} ${product.getAttribute("shop-curreny")}`;
        }

        if (newComparePrice) {
          if (newComparePrice > newPrice) {
            productComparePrice.innerHTML = `${newComparePrice.toFixed(
              2,
            )} ${product.getAttribute("shop-curreny")}`;

            discountPer.querySelector("span").textContent =
              `${Math.round(finalPercentage)}% OFF`;
            discountPer.classList.remove("compare-price-hide");
          } else {
            productComparePrice.innerHTML = ``;
            discountPer.querySelector("span").innerHTML = "";
            discountPer.classList.add("compare-price-hide");
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    function updateVariant() {
      let selectedOptions = [];

      document
        .querySelectorAll(".variant-option input[type='radio']:checked")
        .forEach((select) => {
          selectedOptions.push(select.value);
        });

      let matchedVariant = productVariant.find((v) =>
        selectedOptions.every((opt, i) => v[`option${i + 1}`] === opt),
      );

      if (!matchedVariant || !matchedVariant.featured_media) return;

      let targetedMediaID = matchedVariant.featured_media.id;

      let swiperEl = document.querySelector(
        ".custom-product-page-swiper-container",
      );
      if (!swiperEl || !swiperEl.swiper) return;

      let targetedSlide = swiperEl.querySelector(
        `swiper-slide[data-media-id="${targetedMediaID}"]`,
      );

      if (!targetedSlide) return;

      let index = [...swiperEl.swiper.slides].indexOf(targetedSlide);

      swiperEl.swiper.slideToLoop
        ? swiperEl.swiper.slideToLoop(index)
        : swiperEl.swiper.slideTo(index);
    }

    updatePrice();
  }, 500);
} catch (error) {
  console.log(error);
}

//Enlarger
// try {
//   let enlargerOpenBtn = document.querySelectorAll(
//     ".custom-product-img-enlarger-icon",
//   );
//   let enlargerCloseBtn = document.querySelector(".enlarger-close-btn");
//   let enlargerWrapper = document.querySelector(".custom-product-img-enlarger");
//   let enlargerCon = document.querySelector(
//     ".custom-product-img-enlarger-container",
//   );

//   enlargerOpenBtn.forEach((btn) => {
//     btn.addEventListener("click", () => {
//       let closestImgSrc = btn.parentElement
//         .querySelector("img")
//         .getAttribute("src");
//       // console.log(closestImgSrc);
//       let img = document.createElement("img");
//       img.setAttribute("draggable", "false");
//       img.setAttribute("src", closestImgSrc);
//       // console.log(img);
//       img.classList.add("product-img-class");
//       enlargerWrapper.innerHTML = "";
//       enlargerWrapper.append(img);
//       enlargerCon.classList.add("custom-product-img-enlarger-container-class");
//       if (window.innerWidth > 769) {
//         enableImageDrag(img);
//       } else {
//         img.classList.remove("product-img-class");
//       }
//     });
//   });

//   enlargerCloseBtn.addEventListener("click", () => {
//     enlargerCon.classList.remove("custom-product-img-enlarger-container-class");
//   });

//   function enableImageDrag(img) {
//     let isDraggable = false;
//     let startX, startY, initialLeft, initialTop;

//     img.style.position = "absolute";
//     img.style.top = "50%";
//     img.style.left = "50%";
//     img.style.transform = "translate(-50%, -50%) scale(1.5)";
//     img.style.cursor = "grab";

//     img.addEventListener("mousedown", (e) => {
//       isDraggable = true;
//       img.style.transition = "none";
//       img.style.cursor = "grabbing";

//       // Get current position of the image (after transforms)
//       const rect = img.getBoundingClientRect();

//       // Calculate starting mouse position and element offsets
//       startX = e.clientX;
//       startY = e.clientY;

//       // Compute initial top/left in pixels relative to parent container
//       const computedStyle = window.getComputedStyle(img);
//       initialLeft = parseFloat(computedStyle.left);
//       initialTop = parseFloat(computedStyle.top);

//       document.body.style.userSelect = "none";
//     });

//     window.addEventListener("mousemove", (e) => {
//       if (!isDraggable) return;

//       // Delta from initial click
//       const dx = e.clientX - startX;
//       const dy = e.clientY - startY;

//       // Move image smoothly while maintaining scale
//       img.style.left = `${initialLeft + dx}px`;
//       img.style.top = `${initialTop + dy}px`;
//       img.style.transform = `translate(-50%, -50%) scale(1.5)`;
//     });

//     window.addEventListener("mouseup", () => {
//       if (isDraggable) {
//         isDraggable = false;
//         img.style.cursor = "grab";
//         document.body.style.userSelect = "";
//         img.style.transition = ".3s ease";
//         // Snap back to center if desired
//         img.style.top = `50%`;
//         img.style.left = `50%`;
//         img.style.transform = `translate(-50%, -50%) scale(1.5)`;
//       }
//     });
//   }
// } catch (error) {
//   console.log(error);
// }

//Enlarger
try {
  let enlargerOpenBtn = document.querySelectorAll(
    ".custom-product-page-swiper-slide img",
  );
  let enlargerCloseBtn = document.querySelector(".enlarger-close-btn");
  let enlargerWrapper = document.querySelector(".custom-product-img-enlarger");
  let enlargerSwiperCon = document.querySelector(".custom-enlarger-swiper-con");
  let enlargerCon = document.querySelector(
    ".custom-product-img-enlarger-container",
  );

  enlargerOpenBtn.forEach((btn) => {
    btn.addEventListener("click", () => {
      // enlargerSwiperCon.innerHTML = "";
      let oldImgIndex = Number(
        btn.parentElement.closest("swiper-slide").getAttribute("img-index"),
      );
      let REALswiperSlidesPicture = document.querySelectorAll(
        ".custom-product-page-swiper-slide img",
      );

      let count = -1;
      REALswiperSlidesPicture.forEach((picture) => {
        count++;
        let newSwiperSlidesPicture = document.createElement("picture");
        newSwiperSlidesPicture.innerHTML = picture.outerHTML;
        console.log(newSwiperSlidesPicture);

        // let ORGdataID = picture.closest("swiper-slide").getAttribute("data-media-id");
        // let NEWdataID = swiperSlide.getAttribute("data-media-id");

        let swiperSlide = document.createElement("swiper-slide");
        swiperSlide.classList.add("custom-enlarger-swiper-slide");
        // swiperSlide.setAttribute("data-media-id", ORGdataID);
        swiperSlide.setAttribute("img-index", count);

        let newImgIndex = Number(swiperSlide.getAttribute("img-index"));

        if (newImgIndex == oldImgIndex) {
          enlargerSwiperCon.swiper.slideToLoop
            ? enlargerSwiperCon.swiper.slideToLoop(oldImgIndex)
            : enlargerSwiperCon.swiper.slideTo(oldImgIndex);
          console.log(oldImgIndex);
        }

        swiperSlide.append(newSwiperSlidesPicture);
        // let img = newSwiperSlidesPicture.querySelector("img");
        // img.setAttribute("draggable", "false");
        enlargerSwiperCon.append(swiperSlide);
        // enableImageDrag(img);
      });

      // let closestImgSrc = btn.getAttribute("src");
      // // console.log(closestImgSrc);
      // let img = document.createElement("img");
      // img.setAttribute("src", closestImgSrc);
      // console.log(img);
      // img.classList.add("product-img-class");
      // enlargerWrapper.append(img);
      enlargerCon.classList.add("custom-product-img-enlarger-container-class");
    });
  });

  // function userInteraction() {
  //   const swiper = enlargerSwiperCon.swiper;

  //   if (!swiper) return;

  //   swiper.params.allowTouchMove = window.innerWidth < 768;
  //   swiper.allowTouchMove = window.innerWidth < 768;

  //   swiper.update();
  // }

  // userInteraction();
  // window.addEventListener("resize", userInteraction);

  enlargerCloseBtn.addEventListener("click", () => {
    enlargerCon.classList.remove("custom-product-img-enlarger-container-class");
  });

  function enableImageDrag(img) {
    let isDraggable = false;
    let startX, startY, initialLeft, initialTop;

    img.style.position = "absolute";
    img.style.top = "50%";
    img.style.left = "50%";
    if (window.innerWidth > 768) {
      img.style.transform = `translate(-50%, -50%) scale(1.2)`;
    } else {
      img.style.transform = `translate(-50%, -50%)`;
    }
    img.style.cursor = "grab";

    img.addEventListener("mousedown", (e) => {
      isDraggable = true;
      img.style.transition = "none";
      img.style.cursor = "grabbing";

      // Get current position of the image (after transforms)
      const rect = img.getBoundingClientRect();

      // Calculate starting mouse position and element offsets
      startX = e.clientX;
      startY = e.clientY;

      // Compute initial top/left in pixels relative to parent container
      const computedStyle = window.getComputedStyle(img);
      initialLeft = parseFloat(computedStyle.left);
      initialTop = parseFloat(computedStyle.top);

      document.body.style.userSelect = "none";
    });

    window.addEventListener("mousemove", (e) => {
      if (!isDraggable) return;

      // Delta from initial click
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      // Move image smoothly while maintaining scale
      img.style.left = `${initialLeft + dx}px`;
      img.style.top = `${initialTop + dy}px`;
      if (window.innerWidth > 768) {
        img.style.transform = `translate(-50%, -50%) scale(1.2)`;
      } else {
        img.style.transform = `translate(-50%, -50%)`;
      }
    });

    window.addEventListener("mouseup", () => {
      if (isDraggable) {
        isDraggable = false;
        img.style.cursor = "grab";
        document.body.style.userSelect = "";
        img.style.transition = ".3s ease";
        // Snap back to center if desired
        img.style.top = `50%`;
        img.style.left = `50%`;
        if (window.innerWidth > 768) {
          img.style.transform = `translate(-50%, -50%) scale(1.2)`;
        } else {
          img.style.transform = `translate(-50%, -50%)`;
        }
      }
    });
  }
} catch (error) {
  console.log(error);
}

try {
  let isMobile = false;

  function animationSection() {
    isMobile = window.innerWidth < 769;

    const sections = document.querySelectorAll(
      ".custom-animation-section-img-wrapper",
    );

    sections.forEach((section) => {
      const link = section.querySelector("a");
      const button = section.querySelector(
        ".custom-animation-section-mbl-button",
      );

      if (!isMobile) {
        // Desktop
        section.classList.remove("animation-active");

        const saveURL = section.getAttribute("saveURL");

        link.setAttribute("href", saveURL);
        button.style.opacity = "0";
      } else {
        // Mobile
        link.removeAttribute("href");
        button.style.opacity = "0";
        section.classList.remove("animation-active");
      }
    });
  }

  // Run on page load
  animationSection();

  // Run when screen size changes
  window.addEventListener("resize", animationSection);

  // ONE click listener only
  document.addEventListener("click", (e) => {
    // Desktop → do nothing
    if (!isMobile) return;

    // If SEE DETAILS was clicked → allow its link to work
    if (e.target.closest(".custom-animation-section-mbl-button")) {
      return;
    }

    const btn = e.target.closest(".custom-animation-section-img-wrapper");

    if (!btn) return;

    const isActive = btn.classList.contains("animation-active");

    // Reset all sections
    document
      .querySelectorAll(".custom-animation-section-img-wrapper")
      .forEach((section) => {
        section.classList.remove("animation-active");

        section.querySelector(
          ".custom-animation-section-mbl-button",
        ).style.opacity = "0";
      });

    // Activate clicked section
    if (!isActive) {
      btn.classList.add("animation-active");

      btn.querySelector(".custom-animation-section-mbl-button").style.opacity =
        "1";
    }
  });
} catch (error) {
  console.log(error);
}

try {
  const dropdown = document.querySelector("#dropdownSelect");

  function lang() {
    const country = Shopify.country;
    const savedLanguage = localStorage.getItem("languagePreference");

    // Don't auto-switch if the customer has already chosen a language
    if (savedLanguage) return;

    // Saudi → Arabic
    if (
      country === "SA" &&
      !window.location.pathname.startsWith("/ar")
    ) {
      window.location.href = `/ar${window.location.pathname}`;
    }
  }

  // User manually changes language
  dropdown.addEventListener("change", () => {
    const selectedLanguage = dropdown.value;

    // Remember their choice
    localStorage.setItem("languagePreference", selectedLanguage);

    // Don't automatically change it
    if (selectedLanguage === "en") return;

    lang();
  });

  // Automatically detect language on first visit
  lang();
} catch (error) {
 console.log(error) 
}